import { InkGold } from './InkGold';

export default InkGold;
